var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBookSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3940",
    "data-name": "Group 3940",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.106,
    height: 26,
    viewBox: "0 0 21.106 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1161",
    "data-name": "Rectangle 1161",
    width: 21.106,
    height: 26,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3939",
    "data-name": "Group 3939",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2925",
    "data-name": "Path 2925",
    d: "M0,12.992q0-4.838,0-9.676A3.3,3.3,0,0,1,2.168.207,3.691,3.691,0,0,1,3.46,0q7.1-.006,14.2,0a3.3,3.3,0,0,1,3.352,2.53,3.146,3.146,0,0,1,.094.764q0,8.459,0,16.918a.823.823,0,0,1-.9.879q-8.416,0-16.832,0a1.674,1.674,0,1,0-.146,3.342q8.4-.009,16.8,0a1.478,1.478,0,0,1,.509.054.83.83,0,0,1,.557.758.816.816,0,0,1-.651.708,2.7,2.7,0,0,1-.483.04q-8.23,0-16.46,0a3.315,3.315,0,0,1-3.4-2.51,3.272,3.272,0,0,1-.1-.82q0-2.419,0-4.838t0-4.838m1.561-1.628V14.2q0,2.733,0,5.467c0,.232.029.317.282.185a2.761,2.761,0,0,1,1.3-.286q8,0,16,0c.4,0,.4,0,.4-.39q0-2.6,0-5.209c0-3.54-.017-7.079.009-10.619a1.711,1.711,0,0,0-1.8-1.8c-4.8.024-9.6.011-14.4.012a2.152,2.152,0,0,0-.512.033A1.6,1.6,0,0,0,1.567,3.321q-.006,4.021,0,8.043",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2926",
    "data-name": "Path 2926",
    d: "M99.941,95.665a4.435,4.435,0,0,1,3.754,6.776.3.3,0,0,0,.052.438q1.376,1.357,2.735,2.731a.782.782,0,0,1-.017,1.188.578.578,0,0,1-.806.026,6.253,6.253,0,0,1-.5-.471c-.8-.8-1.61-1.6-2.406-2.412a.336.336,0,0,0-.5-.072,4.43,4.43,0,1,1-2.309-8.2m2.87,4.429a2.882,2.882,0,1,0-2.895,2.9,2.926,2.926,0,0,0,2.895-2.9",
    transform: "translate(-90.6 -90.757)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookSearch);
export default __webpack_public_path__ + "static/media/icon_book_search.98c8887c2b3227798c7708f15770b545.svg";
export { ForwardRef as ReactComponent };